import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import { TextField, Select } from "../inputs";
import { useFormik } from "formik";
import * as Yup from "yup";
import countryCodes from "./helpers/countryData";

export interface AddPhoneNumberFormInterface {
  initialData: { phone: string; code: string };
  handleAction: (type: string, data?: any) => void;
  schema: any;
}
const AddPhoneNumberForm = ({
  initialData,
  handleAction,
  schema,
}: AddPhoneNumberFormInterface) => {
  const { values, handleChange, handleBlur, handleSubmit, touched, errors } =
    useFormik({
      initialValues: initialData,
      validationSchema: Yup.object(schema),
      onSubmit: (value) => handleAction("submit", value),
    });
  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", height: "100%" }}>
      <Stack
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height="100%"
      >
        <Typography variant="h1" fontWeight={700} textAlign="center">
          Add a phone number for security
        </Typography>

        <Stack direction="row" width="100%" alignItems="center" spacing={2}>
          <Select
            label="Country Code"
            options={countryCodes.map((option) => ({
              value: option.code,
              label: `${option.code} | ${option.country}`,
            }))}
            name="code"
            id="code"
            placeholder="Select Code"
            helperText={touched.code ? errors.code : ""}
            error={touched.code && Boolean(errors.code)}
            value={values.code}
            onChange={handleChange}
            onBlur={handleBlur}
            minWidth="120px"
          />

          <TextField
            label="Phone number"
            name="phone"
            id="phone"
            placeholder="phone"
            helperText={touched.phone ? errors.phone : ""}
            error={touched.phone && Boolean(errors.phone)}
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Stack>
        <Stack
          spacing={5}
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            variant="text"
            sx={{ color: "#000", width: "fit-content" }}
            fullWidth
            onSubmit={() => handleAction("skipPhoneNumber")}
          >
            Skip
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
          >
            Add Number
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
export default AddPhoneNumberForm;
